import pad from './pad';
export default function dateToString(date, options) {
  return "".concat(date.year, "-").concat(pad(date.month + (options && options.fixMonth ? 1 : 0)), "-").concat(pad(date.day));
}